import { Injectable } from '@angular/core';
import { ApiRequest } from '@caslink/common-client/ng-app/proxy/typings/models';
import { IResponse } from '@caslink/common-client/ng-app/proxy/typings/IResponse';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { ProxyServiceAdapter } from '@caslink/common-client/ng-app/proxy/ProxyServiceAdapter';
import { DevicesHttpService } from '../../common/services/devices-http.service';
import { AuthenticationService } from '../../../user/services/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class ProxyAdapterService extends ProxyService {

    public get endpoints() {
        return {
                hardware: {
                    routes: {
                        updateControlSummary: {
                            routeTemplate: 'hardware/{hardwareItemId}/summary',
                            method: 'PUT',
                            paramNames: []
                        },
                        saveControlSummary: {
                            routeTemplate: 'hardware/{hardwareItemId}/settings/summary/save',
                            method: 'PUT',
                            paramNames: []
                        },
                        saveSystemInformation: {
                            routeTemplate: 'hardware/{hardwareItemId}/settings/dynamic/save',
                            method: 'PUT',
                            paramNames: [],
                        },
                        saveCurrentInformation: {
                            routeTemplate: 'hardware/{hardwareItemId}/settings/currentInfo/save',
                            method: 'PUT',
                            paramNames: [],
                        }
                    },
                    baseUrl: this.deviceHttpService.host,
                }
            };
    }

    constructor(
        private proxyServiceAdapter: ProxyServiceAdapter,
        private deviceHttpService: DevicesHttpService,
        private authenticationService: AuthenticationService,
    ) {
        super(proxyServiceAdapter.$rootScope,
            proxyServiceAdapter.$timeout,
            proxyServiceAdapter.appContextService,
            proxyServiceAdapter.endpointService,
            proxyServiceAdapter.$log,
            proxyServiceAdapter.$q,
            proxyServiceAdapter.$http,
            proxyServiceAdapter.httpClient,
            proxyServiceAdapter.commonBroadcastService,
            );
    }

    public request(request: ApiRequest): IResponse {
        const endpoint = this.endpoints[request.endPoint];

        if (!endpoint) {
            throw Error('no hardcoded endpoint found!');
        }

        this.addTokenToRequest(request);

        const route = endpoint && endpoint.routes[request.route];
        route.routeTemplate = endpoint.baseUrl + route.routeTemplate;

        return super.callRoute(route, request);
    }

    public watchForLoadingNotification() {
        // Empty override for now
    }

    private addTokenToRequest(request: ApiRequest) {
        const token = 'Bearer ' + this.authenticationService.getAccessToken();
        request.headers = request.headers || {};
        request.headers.Authorization = token;
    }
}
